export default "__VITE_ASSET__83c2bfaf__"